<template>
  <div class="card shadow-4 h-100">
    <div class="card-body">
      <h3 class="text-uppercase text-success mb-5 pl-5">Offre BUSINESS</h3>
      <p class="card-description">Activez l'offre BUSINESS et bénéficiez de nombreux avantages supplémentaires</p>
      <img src="assets/img/cover-business.jpg" alt="">
      <div style="position: relative">
        <i class="fas fa-stars text-warning lead-3" style="position: absolute; top: -1%; right: 13%; transform: rotate(-45deg); font-size: 1rem"></i>
        <i class="fas fa-stars text-warning lead-3" style="position: absolute; top: 4%; left: 14%; transform: rotate(45deg)"></i>
        <div class="d-flex justify-content-center my-6">
          <button data-toggle="modal" class="btn btn-round btn-success w-75" @click="migrateToBusiness()">
            Migrer vers l'offre BUSINESS
          </button>
        </div>
        <div class="text-center">
          <div>ou demandez une démo à votre référent produit Bubble Plan</div>
        </div>
      </div>
    </div>
    <!-- MODAL UPGRADE PAYMENT -->
    <div id="myModalBusiness" class="modal fade" role="dialog">
      <div class="modal-dialog modal-xl">
        <div class="modal-content" style="background-color: #fcfcfc">
          <div class="modal-header">
            <h5 class="modal-title">Valider votre commande</h5>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>
          <div class="row mt-2 px-5 px-sm-8">
            <div class="col-5">
              <div class="w-100 badge badge-primary px-3 rounded" style="line-height: unset">
                {{ availablePlans[billingPlan].name }}
              </div>
            </div>
            <div class="col-2 text-warning text-center">
              <i class="fas fa-arrow-right" style="font-size: 150%; line-height: 150%;"></i>
            </div>
            <div class="col-5">
              <div class="w-100 badge badge-success px-3 rounded" style="line-height: unset">
                {{ availablePlans[businessPlan].name }}
              </div>
            </div>
          </div>
          <div class="modal-body text-center">
            <p class="text-primary"><b>Récapitulatif de votre commande</b></p>
            <table class="w-100">
              <tr>
                <td class="py-1 text-left">Abonnement Business pour vos {{ premiumMaxUsers }} utilisateurs</td>
                <td class="px-3"></td>
                <td>{{ priceUpgradeUsers.price }} €</td>
              </tr>
              <hr class="my-2">
              <tr>
                <td class="py-1 text-left">TVA 20%</td>
                <td class="px-3"></td>
                <td>{{ priceUpgradeUsers.vat }} €</td>
              </tr>
              <hr class="my-2">
              <tr>
                <td class="py-1 text-left">Total TTC mensuel</td>
                <td class="px-3"></td>
                <td>{{ priceUpgradeUsers.total }} €</td>
              </tr>
            </table>
            <div class="mt-2 text-muted text-left" style="line-height: 1.3">
              <small>Le changement sera répercuté sur la prochaine facture au prorata de la période en cours.</small>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Annuler</button>
            <button :disabled="loading" type="button" class="btn btn-success" @click="submitUpgradeBusiness()">Valider</button>
          </div>
        </div>
      </div>
    </div>
    <!-- END MODAL -->
    <!-- MODAL UNAUTHORIZED MODIFICATION BUSINESS -->
    <div id="unauthorizedMigrateBusiness" class="modal fade" data-backdrop="static" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Vous n'avez pas les droits nécessaires</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            Seul un <b>administrateur du compte</b> peut valider le passage à l'offre BUSINESS.<br>
            Merci de vous rapprocher d'un administrateur ou de nous contacter à <a href="mailto:premium@bubbleplan.net">premium@bubbleplan.net</a> en cas d'indisponibilité.
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal">Fermer</button>
          </div>
        </div>
      </div>
    </div>
    <!-- END MODAL UNAUTHORIZED MODIFICATION BUSINESS -->
  </div>
</template>

<script>
  import apiSrv from '../apiSrv';

  export default {
    props: {
      user: { type: Object, required: true },
      availablePlans: { type: Object, required: true },
    },
    data() {
      return {
        loading: false,
      };
    },
    computed: {
      isAdmin() { return this.user.access_right == 'company_admin'; },
      billingPlan() { return this.user.company && this.user.company.billing_plan; },
      businessPlan() { return this.billingPlan.replace('TEAM', 'BUSINESS'); },
      premiumMaxUsers() { return this.user.company && this.user.company.maxusers; },
      priceUpgradeUsers() {
        if (! ['BUSINESS', 'BUSINESS12M'].includes(this.businessPlan)) {
          console.error('Plan check error', this.businessPlan, this.billingPlan);
          return {};
        }
        const priceHT = this.availablePlans[this.businessPlan].price * this.premiumMaxUsers;
        return {
          price: this.number_format(priceHT),
          vat: this.number_format(priceHT * 0.20),
          total: this.number_format(priceHT * 1.20),
        };
      },
    },
    methods: {
      number_format(nbr) {
        let nbrFixed = nbr.toFixed(2);
        if (nbrFixed.endsWith('.00')) nbrFixed = nbrFixed.slice(0, -3);
        const nbrFormated = nbrFixed.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        return nbrFormated.replace('.', ',');
      },
      migrateToBusiness() {
        if (this.isAdmin) {
          $('#myModalBusiness').modal('show');
        } else {
          $('#unauthorizedMigrateBusiness').modal('show');
        }
      },
      submitUpgradeBusiness() {
        this.loading = true;
        apiSrv.call(`${window.api.buy.url}/plan/upgrade/${this.businessPlan}`, 'PUT').then(() => {
          window.location.reload();
        }).catch((message) => {
          this.loading = false;
          console.log(message);
        });
      },
    },
  };
</script>
